import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import ReleaseScheduleAction from './release-schedule-action-model'
import {
  CreateReleaseScheduleActionAsync,
  DeleteReleaseScheduleActionAsync,
  LoadReleaseScheduleActionsAsync,
} from './releaseScheduleAction-thunk'
const initialState: releaseScheduleActionSliceState = {
  releaseScheduleAction: [],
  selected_releaseScheduleAction: '',
  is_loading_releaseScheduleAction: false,
  is_creating_releaseScheduleAction: false,
  is_deleting_releaseScheduleAction: false,
}
export interface releaseScheduleActionSliceState {
  releaseScheduleAction: ReleaseScheduleAction[]
  selected_releaseScheduleAction?: string
  is_loading_releaseScheduleAction: boolean
  is_creating_releaseScheduleAction: boolean
  is_deleting_releaseScheduleAction: boolean
}
export const releaseScheduleActionSlice = createSlice({
  name: 'releaseScheduleAction',
  initialState,
  reducers: {
    setSelectedreleaseScheduleAction: (state, action) => {
      state.selected_releaseScheduleAction = action.payload
    },
    clearStatereleaseScheduleAction: (state) => {
      state.releaseScheduleAction = []
      state.is_loading_releaseScheduleAction = false
      state.is_creating_releaseScheduleAction = false
      state.is_deleting_releaseScheduleAction = false
    },
    mergereleaseScheduleAction: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_releaseScheduleAction = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.releaseScheduleAction = merge(
            state.releaseScheduleAction,
            payload,
          ) as any
        }
      }
    },

    add_releaseScheduleAction: (state, action) => {
      if (action.payload) {
        state.releaseScheduleAction = [
          ...state.releaseScheduleAction,
          action.payload,
        ]
      }
    },
    set_releaseScheduleAction: (state, action) => {
      let { key, value, id } = action.payload
      state.releaseScheduleAction = state.releaseScheduleAction.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadReleaseScheduleActionsAsync.pending, (state) => {
      state.is_loading_releaseScheduleAction = true
    })
    builder.addCase(
      LoadReleaseScheduleActionsAsync.fulfilled,
      (state, action) => {
        state.is_loading_releaseScheduleAction = false
        if (action.payload) {
          state.releaseScheduleAction = action.payload
        }
      },
    )
    builder.addCase(LoadReleaseScheduleActionsAsync.rejected, (state) => {
      state.is_loading_releaseScheduleAction = false
    })
    builder.addCase(CreateReleaseScheduleActionAsync.pending, (state) => {
      state.is_creating_releaseScheduleAction = true
    })
    builder.addCase(CreateReleaseScheduleActionAsync.fulfilled, (state) => {
      state.is_creating_releaseScheduleAction = false
    })
    builder.addCase(CreateReleaseScheduleActionAsync.rejected, (state) => {
      state.is_creating_releaseScheduleAction = false
    })
    builder.addCase(DeleteReleaseScheduleActionAsync.pending, (state) => {
      state.is_deleting_releaseScheduleAction = true
    })
    builder.addCase(
      DeleteReleaseScheduleActionAsync.fulfilled,
      (state, action) => {
        state.is_deleting_releaseScheduleAction = false
        if (state.releaseScheduleAction) {
          state.releaseScheduleAction = state.releaseScheduleAction.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteReleaseScheduleActionAsync.rejected, (state) => {
      state.is_deleting_releaseScheduleAction = false
    })

    builder.addCase(
      autoThunks
        .get_releasescheduleactions_for_release_management_by_content_house
        .pending,
      (state) => {
        state.is_loading_releaseScheduleAction = true
      },
    )
    builder.addCase(
      autoThunks
        .get_releasescheduleactions_for_release_management_by_content_house
        .fulfilled,
      (state, action) => {
        state.is_loading_releaseScheduleAction = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks
        .get_releasescheduleactions_for_release_management_by_content_house
        .rejected,
      (state) => {
        state.is_loading_releaseScheduleAction = false
      },
    )

    builder.addCase(
      autoThunks.update_release_schedule_action_for_release_management.pending,
      (state) => {
        state.is_loading_releaseScheduleAction = true
      },
    )
    builder.addCase(
      autoThunks.update_release_schedule_action_for_release_management
        .fulfilled,
      (state, action) => {
        state.is_loading_releaseScheduleAction = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.update_release_schedule_action_for_release_management.rejected,
      (state) => {
        state.is_loading_releaseScheduleAction = false
      },
    )

    builder.addCase(
      autoThunks.get_release_schedule_actions_for_coherent_screens.pending,
      (state) => {
        state.is_loading_releaseScheduleAction = true
      },
    )
    builder.addCase(
      autoThunks.get_release_schedule_actions_for_coherent_screens.fulfilled,
      (state, action) => {
        state.is_loading_releaseScheduleAction = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_release_schedule_actions_for_coherent_screens.rejected,
      (state) => {
        state.is_loading_releaseScheduleAction = false
      },
    )

    builder.addCase(
      autoThunks.get_release_schedule_actions_for_coherent_screen_list.pending,
      (state) => {
        state.is_loading_releaseScheduleAction = true
      },
    )
    builder.addCase(
      autoThunks.get_release_schedule_actions_for_coherent_screen_list
        .fulfilled,
      (state, action) => {
        state.is_loading_releaseScheduleAction = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_release_schedule_actions_for_coherent_screen_list.rejected,
      (state) => {
        state.is_loading_releaseScheduleAction = false
      },
    )

    builder.addCase(
      autoThunks.update_release_schedule_actions_for_coherent_screens.pending,
      (state) => {
        state.is_loading_releaseScheduleAction = true
      },
    )
    builder.addCase(
      autoThunks.update_release_schedule_actions_for_coherent_screens.fulfilled,
      (state, action) => {
        state.is_loading_releaseScheduleAction = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.update_release_schedule_actions_for_coherent_screens.rejected,
      (state) => {
        state.is_loading_releaseScheduleAction = false
      },
    )

    builder.addCase(
      autoThunks.get_release_schedule_actions_for_curated_media_lists.pending,
      (state) => {
        state.is_loading_releaseScheduleAction = true
      },
    )
    builder.addCase(
      autoThunks.get_release_schedule_actions_for_curated_media_lists.fulfilled,
      (state, action) => {
        state.is_loading_releaseScheduleAction = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_release_schedule_actions_for_curated_media_lists.rejected,
      (state) => {
        state.is_loading_releaseScheduleAction = false
      },
    )

    builder.addCase(
      autoThunks.get_release_schedule_actions_for_curated_media_list.pending,
      (state) => {
        state.is_loading_releaseScheduleAction = true
      },
    )
    builder.addCase(
      autoThunks.get_release_schedule_actions_for_curated_media_list.fulfilled,
      (state, action) => {
        state.is_loading_releaseScheduleAction = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_release_schedule_actions_for_curated_media_list.rejected,
      (state) => {
        state.is_loading_releaseScheduleAction = false
      },
    )

    builder.addCase(
      autoThunks.update_release_schedule_actions_for_curated_media_list.pending,
      (state) => {
        state.is_loading_releaseScheduleAction = true
      },
    )
    builder.addCase(
      autoThunks.update_release_schedule_actions_for_curated_media_list
        .fulfilled,
      (state, action) => {
        state.is_loading_releaseScheduleAction = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.update_release_schedule_actions_for_curated_media_list
        .rejected,
      (state) => {
        state.is_loading_releaseScheduleAction = false
      },
    )

    builder.addCase(
      autoThunks.get_release_schedule_actions_for_curated_lists.pending,
      (state) => {
        state.is_loading_releaseScheduleAction = true
      },
    )
    builder.addCase(
      autoThunks.get_release_schedule_actions_for_curated_lists.fulfilled,
      (state, action) => {
        state.is_loading_releaseScheduleAction = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_release_schedule_actions_for_curated_lists.rejected,
      (state) => {
        state.is_loading_releaseScheduleAction = false
      },
    )

    builder.addCase(
      autoThunks.get_release_schedule_actions_for_curated_list.pending,
      (state) => {
        state.is_loading_releaseScheduleAction = true
      },
    )
    builder.addCase(
      autoThunks.get_release_schedule_actions_for_curated_list.fulfilled,
      (state, action) => {
        state.is_loading_releaseScheduleAction = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_release_schedule_actions_for_curated_list.rejected,
      (state) => {
        state.is_loading_releaseScheduleAction = false
      },
    )

    builder.addCase(
      autoThunks.update_release_schedule_actions_for_curated_list.pending,
      (state) => {
        state.is_loading_releaseScheduleAction = true
      },
    )
    builder.addCase(
      autoThunks.update_release_schedule_actions_for_curated_list.fulfilled,
      (state, action) => {
        state.is_loading_releaseScheduleAction = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.update_release_schedule_actions_for_curated_list.rejected,
      (state) => {
        state.is_loading_releaseScheduleAction = false
      },
    )

    builder.addCase(
      autoThunks.get_release_schedule_actions_for_system_schedules.pending,
      (state) => {
        state.is_loading_releaseScheduleAction = true
      },
    )
    builder.addCase(
      autoThunks.get_release_schedule_actions_for_system_schedules.fulfilled,
      (state, action) => {
        state.is_loading_releaseScheduleAction = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_release_schedule_actions_for_system_schedules.rejected,
      (state) => {
        state.is_loading_releaseScheduleAction = false
      },
    )
  },
})

function handleResult(action: any, state: releaseScheduleActionSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_releaseScheduleAction = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.releaseScheduleAction = merge(
        state.releaseScheduleAction,
        payload,
      ) as any
    }
  }
}

export const {
  clearStatereleaseScheduleAction,
  setSelectedreleaseScheduleAction,
  set_releaseScheduleAction,
  mergereleaseScheduleAction,
  add_releaseScheduleAction,
} = releaseScheduleActionSlice.actions

export const get_releaseScheduleAction =
  (id?: string) =>
  (state: {
    releaseScheduleAction: {
      releaseScheduleAction: ReleaseScheduleAction[]
    }
  }): ReleaseScheduleAction | null => {
    let temp = state?.releaseScheduleAction?.releaseScheduleAction?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.releaseScheduleAction?.releaseScheduleAction[0] || null
  }
export const get_selected_releaseScheduleAction = (state: {
  releaseScheduleAction: releaseScheduleActionSliceState
}): ReleaseScheduleAction | null => {
  let id = state?.releaseScheduleAction?.selected_releaseScheduleAction
  let temp = state?.releaseScheduleAction?.releaseScheduleAction?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_releaseScheduleAction = (state: {
  releaseScheduleAction: {
    releaseScheduleAction: ReleaseScheduleAction[]
  }
}): ReleaseScheduleAction[] => {
  let temp = state?.releaseScheduleAction?.releaseScheduleAction
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_releaseScheduleAction_busy = (state: {
  releaseScheduleAction: releaseScheduleActionSliceState
}) => {
  return (
    state?.releaseScheduleAction.is_deleting_releaseScheduleAction ||
    state?.releaseScheduleAction.is_loading_releaseScheduleAction ||
    state?.releaseScheduleAction.is_creating_releaseScheduleAction
  )
}
export const is_deleting_releaseScheduleAction_busy = (state: {
  releaseScheduleAction: releaseScheduleActionSliceState
}) => {
  return state?.releaseScheduleAction.is_deleting_releaseScheduleAction
}
export const is_loading_releaseScheduleAction_busy = (state: {
  releaseScheduleAction: releaseScheduleActionSliceState
}) => {
  return state?.releaseScheduleAction.is_loading_releaseScheduleAction
}
export const is_creating_releaseScheduleAction_busy = (state: {
  releaseScheduleAction: releaseScheduleActionSliceState
}) => {
  return state?.releaseScheduleAction.is_creating_releaseScheduleAction
}

export default releaseScheduleActionSlice.reducer
